module.exports = __webpack_public_path__ + "static/media/29ADMSPC33.b2a63eb4.jpg";